<template>
  <div >
    <el-dialog  title="新建提单" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible="tidanFlag" width="95%" center>
      <div>
      <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
          <el-form-item label="项目名称:" prop="projectType"   >
            <el-select  v-model="goodform.projectType" filterable  placeholder="请选择">
              <el-option v-for="item in XMlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        <!-- 地址组件 -->
        <addDizhiSG :goodform="goodform" ></addDizhiSG>
        <div style="heigth:100%;margin-top:20px" class="addressBox" >
          <h4 class="title">
            <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>货物信息</span>
          </h4>
          <p style=" margin-right: 3px;text-align: right;margin-top: -40px;">
            合计：<span class="red">{{goodform.orderNumber}}</span>件/{{goodform.weight}}吨
          </p>
          <el-table height="200px" size="mini" ref="tabref" :data="goodform.goodInfos" style="width:100%" border center>
            <el-table-column type="index"  label="序号" width="60"></el-table-column>
            <el-table-column label="操作"  width="100">
              <template slot-scope="scope">
                <div>
                 <el-button type="text" size="mini" @click="delGoodFn(scope.$index)">删除</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
            width="100"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="unloadingSite" label="卸点" align="center"
            min-width="250"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="100"
            align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"
            width="160"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center"
            width="230"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)" align="center"
             width="100"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="cargoLocation" label="货位" align="center"
             width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号" align="center"
            width="200"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号" align="center"
            width="200"></el-table-column>
             <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"
             width="100"></el-table-column>
          </el-table>
        </div>
        <div style="margin-top:20px" class="addressBox" >
          <h4 class="title">
            <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>收入信息</span>
          </h4>
          <shouruSG :goodform="goodform"></shouruSG>
        </div>
        <div style="margin-top:20px" class="addressBox" >
          <h4 class="title">
            <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>车辆信息</span>
          </h4>
          <renchexinxiSG :goodform="goodform"></renchexinxiSG>
        </div>
      </el-form>
      </div>
    <div style="margin: 15px auto" class="el-dialog--center">
      <el-button @click="closeDialog" >取消</el-button>
      <el-button type="primary" @click="saveFn()" >提交</el-button>
    </div>
    </el-dialog>

  </div>
</template>

<script>
import { addBill, findCustomerInfoList, getDictionaryDetailList, findPriceVehicleList, getSgpzInfo } from '@/api/newTMS'
import addDizhiSG from '@/views/newTMS/publicFiles/wayAndOrder/addDizhiSG.vue'
import shouruSG from '@/views/newTMS/publicFiles/wayAndOrder/shouruSG.vue'
import renchexinxiSG from '@/views/newTMS/publicFiles/orderManage/renchexinxiSG.vue'
import { toFixed } from '@/utils/util'
export default {
  name: 'addtidan',
  components: {
    addDizhiSG, shouruSG, renchexinxiSG
  },
  props: {
    tidanFlag: {
      type: Boolean,
      default: false
    },
    dataList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      goodform: {
        goodInfos: this.dataList,
        measuringUnit: '吨',
        incomePattern: '0',
        makeTicketYn: '是',
        ticketSystemYn: '是',
        revenueValuation: '0',
        receiptRequest: '纸质回单',
        productTypeName: this.dataList[0].productTypeName,
        billCarriers: [{
          expenditurePattern: '1',
          expenditurePatternName: '现结',
          freightPricingType: '0',
          freightPricingTypeName: '按吨',
          serviceRate: 0,
          collectionType: 1,
          collectionTypeName: '企业',
          freightTaxRate: 9

        }]
      },
      rules: {
        projectType: [
          { required: true, message: '请选择项目名称', trigger: 'blur' }
        ],
        payee: [
          { required: true, message: '请选择结算客户', trigger: 'blur' }
        ],
        orderBusinessType: [
          { required: true, message: '请选择业务类型', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        orderWeight: [
          { required: true, message: '请输入货量', trigger: 'blur' }
        ],
        arrivalTime: [
          { required: true, message: '请选择要求到达时间', trigger: 'blur' }
        ],
        businessUserId: [
          { required: true, message: '请选择业务人员', trigger: 'blur' }
        ],
        incomeUnitPrice: [
          { required: true, message: '请输入收入单价', trigger: 'blur' }
        ],
        incomeAmount: [
          { required: true, message: '请输入收入金额', trigger: 'blur' }
        ],
        payer: [
          { required: true, message: '请输入车队长名称', trigger: 'blur' }
        ],
        payerTaxId: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        expenditurePattern: [
          { required: true, message: '请选择支出方式', trigger: 'blur' }
        ],
        freightPricingType: [
          { required: true, message: '请选择运费计价', trigger: 'blur' }
        ],
        freightUnitPrice: [
          { required: true, message: '请输入运费单价', trigger: 'blur' }
        ],
        allFreightAmount: [
          { required: true, message: '请输入运费金额', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        serviceCharge: [
          { required: true, message: '请输入服务费', trigger: 'blur' }
        ],
        freightTaxRate: [
          { required: true, message: '请输入运费税率', trigger: 'blur' }
        ],
        deliverPerson: [
          { pattern: this.rule.xingming, message: '请输入正确的发货人' }
        ],
        receivingPerson: [
          { pattern: this.rule.xingming, message: '请输入正确的收货人' }
        ],
        taxRate: [
          { required: true, message: '请输入收入税率', trigger: 'blur' }
        ]
      },
      XMlist: []

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.goodform.xiedian = this.dataList[0].unloadingSite.replace(/\//g, '').replace(/-/g, '')
    findCustomerInfoList({
      pageNo: 1,
      businessType: 1,
      pageSize: 50,
      customerName: '首钢京唐钢铁联合有限责任公司'
    }).then(res => {
      this.$set(this.goodform, 'payee', '首钢京唐钢铁联合有限责任公司')
      if (res.list.length == 0) {
        this.$alert('该客户没有维护，请维护该客户！', '系统提示')
      } else {
        this.goodform.payCustomerId = res.list[0].id
        this.goodform.payeeTaxId = res.list[0].customerTaxId
        this.goodform.periodDays = res.list[0].periodDays
        this.goodform.periodDaysType = res.list[0].periodDaysType
      }
    })
    // this.$set(this.goodform, 'businessUnit', localStorage.getItem('orgName'))
    // this.$set(this.goodform, 'businessUnitCode', localStorage.getItem('orgCode'))
    // this.$set(this.goodform, 'businessSubunit', localStorage.getItem('orgSubName'))
    // this.$set(this.goodform, 'businessSubunitCode', localStorage.getItem('orgSubCode'))
    // this.$set(this.goodform, 'businessTenantCode', localStorage.getItem('tenantCode'))
    // this.$set(this.goodform, 'businessTenantName', localStorage.getItem('tenantName'))
    // this.$set(this.goodform, 'businessCompanyName', localStorage.getItem('companyName'))
    // this.$set(this.goodform, 'businessCompanyCode', localStorage.getItem('companyCode'))
    // this.$set(this.goodform, 'businessUser', localStorage.getItem('userName'))
    // this.$set(this.goodform, 'businessUserId', localStorage.getItem('userCode'))
    getSgpzInfo().then(res => {
      this.$set(this.goodform, 'businessUnit', res.createDepartmentName)
      this.$set(this.goodform, 'businessUnitCode', res.createDepartmentCode)
      this.$set(this.goodform, 'businessSubunit', res.ext2)
      this.$set(this.goodform, 'businessSubunitCode', res.ext1)
      this.$set(this.goodform, 'businessTenantCode', res.tenantCode)
      this.$set(this.goodform, 'businessTenantName', res.tenantName)
      this.$set(this.goodform, 'businessSubCompanyName', res.createSubcompanyName)
      this.$set(this.goodform, 'businessSubCompanyCode', res.createSubcompanyCode)
      this.$set(this.goodform, 'businessUser', res.createUser)
      this.$set(this.goodform, 'businessUserId', res.createUserId)
      this.$set(this.goodform, 'businessPhone', res.ext3)
    }).catch(error => {
      this.$message({
        showClose: true,
        message: error.message,
        type: 'error',
        onClose () {
        }
      })
    })

    this.$set(this.goodform, 'orderBusinessTypeName', '配货外发业务')
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => {
      let yewuleixingJson = res.filter(item => item.showName == '配货外发业务')
      if (yewuleixingJson.length == 1) {
        this.$set(this.goodform, 'orderBusinessType', yewuleixingJson[0].itemNo)
      }
    })
    this.$set(this.goodform, 'productTypeName', this.dataList[0].productTypeName)
    getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => {
      let hwlx = res.filter(item => item.showName == this.dataList[0].productTypeName)
      if (hwlx.length == 1) {
        this.$set(this.goodform, 'productType', hwlx[0].itemNo)
      }
    })
    getDictionaryDetailList({ dictionaryType: 'project_type' }).then(res => { this.XMlist = res })
    this.getAllWeight()
  },
  methods: {
    saveFn () {
      this.$refs.goodform.validate((valid) => {
        if (!this.goodform.payCustomerId) {
          this.$alert('“首钢京唐钢铁联合有限责任公司”没有维护，请维护该客户！', '系统提示')
          return
        }
        if (!this.goodform.shFlag) {
          this.$alert('没有匹配到收货地址，请重新选择', '系统提示')
          return
        }
        if (String(this.goodform.receivingAddress || '').includes('无地址')) {
          this.$alert('收货地址不能是“无地址”，请重新选择', '系统提示')
          return
        }

        // 存在任意一项 vehicleId 为空
        const list = this.goodform.billCarriers || []
        const hasEmptyVehicle = list.some(item => !item.vehicleId)
        if (hasEmptyVehicle) {
          this.$alert('存在车辆未选择，请完善车辆信息', '系统提示')
          return
        }

        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          addBill(this.goodform).then(res => {
            loading.close()
            this.$emit('update:tidanFlag', false)
            this.$parent.searchFn()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    delGoodFn (goodIndex) {
      this.goodform.goodInfos.splice(goodIndex, 1)
      this.getAllWeight()
    },
    getAllWeight () {
      this.allWeight = 0
      let allNumber = 0
      this.goodform.goodInfos.forEach(item => {
        if (item.weight) {
          this.allWeight = (this.allWeight * 1000 + item.weight * 1000) / 1000
        }
        if (item.number) {
          allNumber = (allNumber * 1000 + item.number * 1000) / 1000
        }
      })
      this.$set(this.goodform, 'weight', toFixed(this.allWeight, 3))
      this.$set(this.goodform, 'orderWeight', toFixed(this.allWeight, 3))
      this.$set(this.goodform, 'orderNumber', allNumber)
    },
    closeDialog () {
      this.$emit('update:tidanFlag', false)
    },
    // 获取自由车价格
    getziyouchePriceFn () {
      this.goodform.billCarriers.forEach(item => {
        if (item.vehicleOwnership == 1) {
          return
        }
        if (this.goodform.productTypeName && this.goodform.startDirection && this.goodform.endDirection && item.energyTypeName && item.freightPricingTypeName && this.goodform.payee) {
          findPriceVehicleList({
            productTypeName: this.goodform.productTypeName,
            startDirection: this.goodform.startDirection,
            endDirection: this.goodform.endDirection,
            energyTypeName: item.energyTypeName,
            freightPricingTypeName: item.freightPricingTypeName,
            payee: this.goodform.payee
          }).then(res => {
            if (res.price) {
              if (item.freightPricingType == 1) { // 包干
                this.$set(item, 'freightUnitPrice', '')
                this.$set(item, 'freightAmount', res.price)
              } else {
                this.$set(item, 'freightAmount', '')
                this.$set(item, 'freightUnitPrice', res.price)
              }
            } else {
              // this.$set(item, 'freightUnitPrice', '')
              // this.$set(item, 'freightAmount', '')
            }
          })
        }
      })
    }

  },
  computed: {
    ziyouchePriceChange () {
      const { startDirection, endDirection } = this.goodform
      return { startDirection, endDirection }
    }
  },
  watch: {
    ziyouchePriceChange: {
      handler (newVal, oldVal) {
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.getziyouchePriceFn()
        }
      }
    }
  },
  destroyed () {
  }
}
</script>

<style scoped lang='less'>
 /deep/.jiaoyan .el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
</style>
